export default {
  en: {
    'INBOUND_NUMBER': 'Inbound # :'
  }
};